import React, {FC, ReactNode} from 'react';
import {Button} from '@vkontakte/vkui';
import CustomDots from '../CustomDots';
import {useHistory} from 'react-router-dom';
import IntroButton from '../../form/IntroButton';
import classNames from 'classnames';
import './style.scss';

interface IProps {
    imgContainer: ReactNode
    textTitle: string,
    currentPage: number,
    nextSlide: any,
}

const IntroContainer: FC<IProps> = ({imgContainer, textTitle, currentPage, nextSlide}) => {
    const history = useHistory();

    const clickHandler = () => {
        if (currentPage === 2) {
            history.push('/start/tastes')
        }
        nextSlide();
    };

    return (
        <div className="intro">
            <div className="intro__container">
                {imgContainer}
                <div
                    className="intro__title"
                >
                    {textTitle}
                </div>
                <div>
                    <div className="intro__dots">
                        <CustomDots currentSlider={currentPage}/>
                    </div>
                    <div className="intro__button-container">
                        <IntroButton onClick={clickHandler}
                        >
                            Далее
                        </IntroButton>
                    </div>
                    <div className={classNames({
                        "intro__miss": true,
                        "intro__miss--hide": currentPage === 2
                    })}>
                        <Button
                            className="intro__button-miss"
                            onClick={() => history.push('/start/tastes')}
                        >
                            Пропустить
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default IntroContainer;
